module.exports = __webpack_public_path__ + "svg/flags/Korea, Republic of.svg";